// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3pIIn","buttons":"Footer_buttons__1ey2F"};